<div class="modal-header">
  <h4 class="modal-title">Edit Database</h4>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()"><span aria-hidden="true">&times;</span></button>
</div>
<div class="modal-body">
  <form [formGroup]="editForm">
    <!-- Common Fields (Disabled) -->
    <div class="mb-3">
      <label for="host"><b>Host</b></label>
      <input id="host" formControlName="host" class="form-control" />
    </div>
    <div class="mb-3">
      <label for="username"><b>Username</b></label>
      <input id="username" formControlName="username" class="form-control"  />
    </div>

    <!-- Snowflake Fields -->
    <div *ngIf="database.platform_type === 'snowflake'">
      <div class="mb-3">
        <label for="password"><b>Password</b></label>
        <input
          id="password"
          formControlName="password"
          class="form-control"
          [required]="database.platform_type === 'snowflake'"
        />
      </div>
      <div class="mb-3">
        <label for="role"><b>Role</b></label>
        <input
          id="role"
          formControlName="role"
          class="form-control"
          [required]="database.platform_type === 'snowflake'"
        />
      </div>
      <div class="mb-3">
        <label for="warehouse"><b>Warehouse</b></label>
        <input
          id="warehouse"
          formControlName="warehouse"
          class="form-control"
          [required]="database.platform_type === 'snowflake'"
        />
      </div>
    </div>

    <!-- MySQL/PostgreSQL Fields -->
    <div *ngIf="database.platform_type === 'mysql' || database.platform_type === 'postgres'">
      <div class="mb-3">
        <label for="password"><b>Password</b></label>
        <input
          id="password"
          formControlName="password"
          class="form-control"
          [required]="database.platform_type === 'mysql' || database.platform_type === 'postgres'"
        />
      </div>
      <div class="mb-3">
        <label for="port"><b>Port</b></label>
        <input
          id="port"
          formControlName="port"
          class="form-control"
          [required]="database.platform_type === 'mysql' || database.platform_type === 'postgres'"
        />
      </div>
      <div class="mb-3">
        <label for="database"><b>Database</b></label>
        <input
          id="database"
          formControlName="database"
          class="form-control"
          [required]="database.platform_type === 'mysql' || database.platform_type === 'postgres'"
        />
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="save()" [disabled]="editForm.invalid">
    Save
  </button>
  <button type="button" class="btn btn-secondary" (click)="dismiss()">Cancel</button>
</div>
